import React, { useState, useEffect } from "react";
import { connect } from "react-redux";

// Image / Custom Component
import {
  Container,
  Label,
  LabelContent,
  CenterAreaOne,
  CenterAreaTwo,
  Header,
  Content,
  PlayGround,
  MatchBoxStrip,
  CenterArea,
  MatchBoxStripArea,
  MatchBoxStripButton,
  AboutHeader,
  AboutText,
  CenterAbout,
  CenterAboutOne,
  HeaderAbout,
  CenterAboutArea,
  Logo,
  Animation,
  LottieAnimation,
  HeaderTwo,
  Anchor,
  ButtonDiv,
  OuterDiv,
  DivButton,
  ButtonImg,
} from "./InformationStyle";
import stringValues from "../../stringValues";
import Button from "../../component/Button/Button";
import { images as imageValues, images } from "../../imageValues";

// Animation
import scrollAnimation from "../../assets/lottieAnimation/ScrollArrow.json";

// Utils
import { playSound, AxlTracker } from "../../utils";

// Actions
import { playPauseSound } from "../../actions/playPauseSoundAction";
import { changeLanguage } from "../../actions/changeLanguageAction";
import { useAxL } from "../../AxLContext";
import { BeginTitle, LogoDiv, SubTitle } from "../Begin/BeginStyled";
import AxL from "../../axl";

const Information = ({
  onClick,
  changeLanguageState,
  changeLanguage,
  playPauseSound,
  playPauseSoundState,
  onClickShare,
}) => {
  const [mobileWidth, setMobileWidth] = useState(window.innerWidth);
  const axl = useAxL();

  useEffect(() => {
    const handleResize = () => {
      setMobileWidth(window.innerWidth);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <Container>
      {mobileWidth > 1080 ? (
        <>
          <CenterAbout>
            <Header>
              {stringValues[changeLanguageState.data].harshitAgrawal}
              <br />
              <SubTitle>
                {stringValues[changeLanguageState.data].presents}
              </SubTitle>
              <br />
              <BeginTitle
                src={
                  changeLanguageState.data === "en"
                    ? images.MATCHBOXMOMENTOS
                    : images.MATCHBOXMOMENTOSHINDI
                }
                isEnglish={changeLanguageState.data === "en" ? true : false}
              />

              <SubTitle style={{ marginTop: "10px" }}>
                {stringValues[changeLanguageState.data].inCollaborationWith}
              </SubTitle>
              <LogoDiv>
                <Logo style={{ paddingRight: "8px" }} src={images.MAP_LOGO} />
                <Logo
                  style={{ paddingLeft: "8px" }}
                  src={images.TASVEER_GHAR_LOGO}
                />
              </LogoDiv>
            </Header>
            <HeaderTwo
              style={{
                fontSize: 15,
              }}
            >
              {stringValues[changeLanguageState.data].mokshaPatam}
            </HeaderTwo>
            <CenterAboutArea>
              <CenterAboutOne>
                <AboutHeader
                  style={{ width: "90%", marginBottom: 10, marginTop: 490 }}
                >
                  {stringValues[changeLanguageState.data].introduction}
                </AboutHeader>
                <AboutText style={{ width: "90%" }}>
                  {stringValues[changeLanguageState.data].artist}{" "}
                  <Anchor
                    onClick={() => {
                      AxlTracker(
                        axl,
                        "Clicked on Harshit Agrawal",
                        "About = Harshit Agrawal",
                        40,
                        true
                      );
                      axl.sendMessage(
                        AxL.ChildToHost.NAVIGATE,
                        "https://www.instagram.com/harshitrnnh/"
                      );
                    }}
                  >
                    {stringValues[changeLanguageState.data].harshitAgrawal}
                  </Anchor>{" "}
                  {stringValues[changeLanguageState.data].goggleArt}{" "}
                  <Anchor
                    onClick={() => {
                      AxlTracker(
                        axl,
                        "Clicked on Museum of Art & Photography",
                        "About =Museum of Art & Photography",
                        44,
                        true
                      );
                      axl.sendMessage(
                        AxL.ChildToHost.NAVIGATE,
                        "https://www.google.com/url?q=https://artsandculture.google.com/partner/museum-of-art-photography&sa=D&source=docs&ust=1698318826874561&usg=AOvVaw2LyXBtNw_EAeP5g6gh-CAe"
                      );
                    }}
                  >
                    {stringValues[changeLanguageState.data].museum}
                  </Anchor>{" "}
                  and{" "}
                  <Anchor
                    onClick={() => {
                      AxlTracker(
                        axl,
                        "Clicked on Tasveer Ghar",
                        "About = Tasveer Ghar",
                        2,
                        true
                      );
                      axl.sendMessage(
                        AxL.ChildToHost.NAVIGATE,
                        "https://artsandculture.google.com/partner/tasveer-ghar?hl=en"
                      );
                    }}
                  >
                    {stringValues[changeLanguageState.data].tasveerGhar}
                  </Anchor>
                  . <br />
                  <br />
                  <b>
                    {
                      stringValues[changeLanguageState.data]
                        .emergingTechnologies
                    }
                  </b>
                  <br />
                  <br />
                  {stringValues[changeLanguageState.data].startingPoint}
                  <br />
                  <br />
                  {stringValues[changeLanguageState.data].interactiveExperiment}
                  <br />
                  <br />
                  {stringValues[changeLanguageState.data].residency}
                </AboutText>
                <AboutHeader style={{ marginBottom: 10, marginTop: 20 }}>
                  {stringValues[changeLanguageState.data].aboutExperiment}
                </AboutHeader>
                <AboutText>
                  {stringValues[changeLanguageState.data].discover}
                  <br />
                  <br />
                  {stringValues[changeLanguageState.data].culturalHeritage}
                </AboutText>
                <br />
                <AboutHeader style={{ marginBottom: 10 }}>
                  {stringValues[changeLanguageState.data].aboutIndianMatchbox}
                </AboutHeader>
                <AboutText>
                  {stringValues[changeLanguageState.data].matchboxArtwork}
                  <br />
                  <br />
                  {stringValues[changeLanguageState.data].largestCollection}
                  <br />
                  <br />
                  {stringValues[changeLanguageState.data].discoverMore}{" "}
                  <Anchor
                    onClick={() => {
                      AxlTracker(
                        axl,
                        "Clicked on Google Arts & Culture",
                        "About = Google Arts & Culture",
                        40,
                        true
                      );
                      axl.sendMessage(
                        AxL.ChildToHost.NAVIGATE,
                        "https://artsandculture.google.com/partner/tasveer-ghar"
                      );
                    }}
                  >
                    {stringValues[changeLanguageState.data].googleArtsCulture}
                  </Anchor>
                  <br />
                  <br />
                  {stringValues[changeLanguageState.data].thanksPartners}{" "}
                  <Anchor
                    onClick={() => {
                      AxlTracker(
                        axl,
                        "Clicked on  Museum of Art & Photography",
                        "About =  Museum of Art & Photography",
                        40,
                        true
                      );
                      axl.sendMessage(
                        AxL.ChildToHost.NAVIGATE,
                        "https://artsandculture.google.com/partner/museum-of-art-photography"
                      );
                    }}
                  >
                    {stringValues[changeLanguageState.data].museum}
                  </Anchor>{" "}
                  {stringValues[changeLanguageState.data].and}{" "}
                  <Anchor
                    onClick={() => {
                      AxlTracker(
                        axl,
                        "Clicked on  Tasveer Ghar",
                        "About =  Tasveer Ghar",
                        40,
                        true
                      );
                      axl.sendMessage(
                        AxL.ChildToHost.NAVIGATE,
                        "https://artsandculture.google.com/partner/tasveer-ghar?hl=en"
                      );
                    }}
                  >
                    {stringValues[changeLanguageState.data].tasveerGhar}
                  </Anchor>{" "}
                  {stringValues[changeLanguageState.data].physicalCollection}{" "}
                  <Anchor
                    onClick={() => {
                      AxlTracker(
                        axl,
                        "Clicked on Imaginative Identity Creators Pvt. Ltd ",
                        "About = Imaginative Identity Creators Pvt. Ltd ",
                        40,
                        true
                      );
                      axl.sendMessage(
                        AxL.ChildToHost.NAVIGATE,
                        "https://iicreators.com"
                      );
                    }}
                  >
                    {stringValues[changeLanguageState.data].iic}
                  </Anchor>
                </AboutText>
                <br />
                <Animation>
                  <LottieAnimation
                    animationData={scrollAnimation}
                    style={{
                      width: 40,
                      height: 40,
                    }}
                  />
                </Animation>
              </CenterAboutOne>
            </CenterAboutArea>
          </CenterAbout>
          <ButtonDiv>
            <Button
              label={stringValues[changeLanguageState.data].journeyButton}
              onClick={onClick}
              style={{ fontWeight: 600 }}
            />
          </ButtonDiv>
        </>
      ) : (
        <PlayGround>
          {mobileWidth < 1080 && (
            <OuterDiv>
              <DivButton onClick={changeLanguage}>
                <ButtonImg src={images.LANGUAGE} />
              </DivButton>
              <DivButton onClick={playPauseSound}>
                {playPauseSoundState.data ? (
                  <ButtonImg src={images.VOLUMEON} />
                ) : (
                  <ButtonImg src={images.VOLUMEOOF} />
                )}
              </DivButton>
              <DivButton onClick={onClickShare}>
                <ButtonImg src={images.SHAREBUTTON} />
              </DivButton>
            </OuterDiv>
          )}
          <CenterArea>
            <Header>
              {stringValues[changeLanguageState.data].harshitAgrawal}
              <br />
              <SubTitle>
                {stringValues[changeLanguageState.data].presents}
              </SubTitle>
              <br />
              <BeginTitle
                src={
                  changeLanguageState.data === "en"
                    ? images.MATCHBOXMOMENTOS
                    : images.MATCHBOXMOMENTOSHINDI
                }
                isEnglish={changeLanguageState.data === "en" ? true : false}
              />

              <SubTitle style={{ marginTop: "10px" }}>
                {stringValues[changeLanguageState.data].inCollaborationWith}
              </SubTitle>
              <LogoDiv>
                <Logo style={{ paddingRight: "8px" }} src={images.MAP_LOGO} />
                <Logo
                  style={{ paddingLeft: "8px" }}
                  src={images.TASVEER_GHAR_LOGO}
                />
              </LogoDiv>
            </Header>
            <HeaderTwo style={{}}>
              {stringValues[changeLanguageState.data].mokshaPatam}
            </HeaderTwo>
            <CenterAreaOne>
              <AboutHeader
                style={{
                  marginBottom: 10,
                  marginTop: 20,
                }}
              >
                {stringValues[changeLanguageState.data].introduction}
              </AboutHeader>
              <AboutText style={{ width: "90%" }}>
                {stringValues[changeLanguageState.data].artist}{" "}
                <Anchor
                  onClick={() => {
                    AxlTracker(
                      axl,
                      "Clicked on Harshit Agrawal",
                      "About = Harshit Agrawal",
                      40,
                      true
                    );
                    axl.sendMessage(
                      AxL.ChildToHost.NAVIGATE,
                      "https://www.instagram.com/harshitrnnh/"
                    );
                  }}
                >
                  {stringValues[changeLanguageState.data].harshitAgrawal}
                </Anchor>{" "}
                {stringValues[changeLanguageState.data].goggleArt}{" "}
                <Anchor
                  onClick={() => {
                    AxlTracker(
                      axl,
                      "Clicked on Museum of Art & Photography",
                      "About =Museum of Art & Photography",
                      44,
                      true
                    );
                    axl.sendMessage(
                      AxL.ChildToHost.NAVIGATE,
                      "https://www.google.com/url?q=https://artsandculture.google.com/partner/museum-of-art-photography&sa=D&source=docs&ust=1698318826874561&usg=AOvVaw2LyXBtNw_EAeP5g6gh-CAe"
                    );
                  }}
                >
                  {stringValues[changeLanguageState.data].museum}{" "}
                </Anchor>
                and{" "}
                <Anchor
                  onClick={() => {
                    AxlTracker(
                      axl,
                      "Clicked on Tasveer Ghar",
                      "About = Tasveer Ghar",
                      2,
                      true
                    );
                    axl.sendMessage(
                      AxL.ChildToHost.NAVIGATE,
                      "https://artsandculture.google.com/partner/tasveer-ghar?hl=en"
                    );
                  }}
                >
                  {stringValues[changeLanguageState.data].tasveerGhar}
                </Anchor>
                . <br />
                <br />
                <b>
                  {stringValues[changeLanguageState.data].emergingTechnologies}
                </b>
                <br />
                <br />
                {stringValues[changeLanguageState.data].startingPoint}
                <br />
                <br />
                {stringValues[changeLanguageState.data].interactiveExperiment}
                .
                <br />
                <br />
                {stringValues[changeLanguageState.data].residency}
              </AboutText>
              <AboutHeader style={{ marginBottom: 10, marginTop: 20 }}>
                {stringValues[changeLanguageState.data].aboutExperiment}
              </AboutHeader>
              <AboutText>
                {stringValues[changeLanguageState.data].discover}
                <br />
                <br />
                {stringValues[changeLanguageState.data].culturalHeritage}
              </AboutText>
              <br />
              <AboutHeader style={{ marginBottom: 10 }}>
                {stringValues[changeLanguageState.data].aboutIndianMatchbox}
              </AboutHeader>
              <AboutText>
                {stringValues[changeLanguageState.data].matchboxArtwork}
                <br />
                <br />
                {stringValues[changeLanguageState.data].largestCollection}
                <br />
                <br />
                {stringValues[changeLanguageState.data].discoverMore}{" "}
                <Anchor
                  onClick={() => {
                    AxlTracker(
                      axl,
                      "Clicked on Google Arts & Culture",
                      "About = Google Arts & Culture",
                      40,
                      true
                    );
                    axl.sendMessage(
                      AxL.ChildToHost.NAVIGATE,
                      "https://artsandculture.google.com/partner/tasveer-ghar"
                    );
                  }}
                >
                  {stringValues[changeLanguageState.data].googleArtsCulture}
                </Anchor>
                <br />
                <br />
                {stringValues[changeLanguageState.data].thanksPartners}{" "}
                <Anchor
                  onClick={() => {
                    AxlTracker(
                      axl,
                      "Clicked on  Museum of Art & Photography",
                      "About =  Museum of Art & Photography",
                      40,
                      true
                    );
                    axl.sendMessage(
                      AxL.ChildToHost.NAVIGATE,
                      "https://artsandculture.google.com/partner/museum-of-art-photography"
                    );
                  }}
                >
                  {stringValues[changeLanguageState.data].museum}
                </Anchor>{" "}
                {stringValues[changeLanguageState.data].and}{" "}
                <Anchor
                  onClick={() => {
                    AxlTracker(
                      axl,
                      "Clicked on  Tasveer Ghar",
                      "About =  Tasveer Ghar",
                      40,
                      true
                    );
                    axl.sendMessage(
                      AxL.ChildToHost.NAVIGATE,
                      "https://artsandculture.google.com/partner/tasveer-ghar?hl=en"
                    );
                  }}
                >
                  {stringValues[changeLanguageState.data].tasveerGhar}
                </Anchor>{" "}
                {stringValues[changeLanguageState.data].physicalCollection}{" "}
                <Anchor
                  onClick={() => {
                    AxlTracker(
                      axl,
                      "Clicked on Imaginative Identity Creators Pvt. Ltd ",
                      "About = Imaginative Identity Creators Pvt. Ltd ",
                      40,
                      true
                    );
                    axl.sendMessage(
                      AxL.ChildToHost.NAVIGATE,
                      "https://iicreators.com"
                    );
                  }}
                >
                  {stringValues[changeLanguageState.data].iic}
                </Anchor>
              </AboutText>
              <br />
              <Animation style={{ right: 10, bottom: 80 }}>
                <LottieAnimation
                  animationData={scrollAnimation}
                  style={{
                    width: 40,
                    height: 40,
                  }}
                />
              </Animation>
            </CenterAreaOne>
          </CenterArea>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: 20,
            }}
          >
            <Button
              label={stringValues[changeLanguageState.data].journeyButton}
              onClick={onClick}
              style={{ fontWeight: 600 }}
            />
          </div>
        </PlayGround>
      )}
    </Container>
  );
};

const mapStateToProps = (state) => ({
  playPauseSoundState: state.playPauseSound,
  changeLanguageState: state.changeLanguage,
});

const mapDispatchToProps = (dispatch) => ({
  // playPauseSound: (params) => dispatch(playPauseSound(params)),
  // changeLanguage: (params) => dispatch(changeLanguage(params)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Information);
